import { DateOperator } from '../interfaces'

export const DATE_OPERATORS: { [key: string]: string } = {
  at: 'Am',
  from: 'Von',
  to: 'Bis',
}

export const DATE_OPERATOR_ENTRIES = Object.entries(DATE_OPERATORS).map(([k, v]) => ({ id: k as DateOperator, name: v }))
